module.exports = __webpack_public_path__ + "img/avatar.fe758668.png";